import FilePdf from '../../src/legacy/FilePdf.tsx';
export default FilePdf;
